<template>
    <div id="interventiondetailtech">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="logout()" src="/assets/logout.png" alt="logout" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
        </nav>
        <div class="outercircle">
            <div class="homeName">
                Planning
            </div>
            <div id="circle"></div>
        </div>
        <h1>
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
            {{title}}
        </h1>
        <div class="greyBack">
            <div class="title"><b>{{intervention.type}}</b></div>
            <div class="date"><i>{{date}}</i></div>
            <div class="img">
                <div v-on:click="changeSheetState()" class="oneImg"><img src="/assets/pdf.png" alt="PDF" /><span>Fiche d'intervention</span></div>
                    <div id="myModal" v-on:click="changeSheetState()" v-bind:class="[isActiveSheet ? 'modalActive' : 'modalInactive']">
                        <span class="close">&times;</span>
                        <img v-if="!intervention.intervention" class="modal-content whiteback" v-on:click.stop="" src="/assets/nosheet.png">
                        <div v-else class="modal-content whiteback">
                            <h2>Fiche d'intervention</h2>
                            <h4>Coordonnées :</h4>
                            <div class="modalTxt twocolumns" style="text-align:left !important; margin-left:20px;margin-right:20px;">
                                <div v-html="txtLocataire"></div>
                                <div v-html="txtProprio"></div>
                            </div>
                            <h4>Informations :</h4>
                            <div>
                                <div class="smallFont" v-for="(itemInfo, indexInfo) in intervention.intervention.information" :key="indexInfo">
                                    <div class="modalDivCenter">
                                        <span>{{itemInfo.note}}</span><br>
                                        <span>{{itemInfo.status}}</span>
                                    </div>
                                </div>
                            </div>
                            <h4>Actions :</h4>
                            <div>
                                <div class="smallFont" v-for="(itemAction, indexAction) in intervention.intervention.action" :key="indexAction">
                                    <div v-if="itemAction.isInternal || itemAction.isExternal" style="background-coor:#ddd; border-radius: 5px;"  class="modalDivCenter">
                                        <span><b>{{itemAction.name}} :</b></span><br>
                                        <span v-if="itemAction.isInternal">Interne</span>
                                        <span v-if="itemAction.isExternal">Externe</span>
                                        <b style="display:block;">Travail effectué :</b>
                                        <span>{{itemAction.report}}</span><br><br>
                                    </div>
                                </div>
                            </div>
                            <h4>Temps d'intervention :</h4>
                            <div class="textline smallFont">
                                <b class="textLen">Temps technicien principal :</b>
                                <span>{{mainTechHour}} h </span>
                                <span>{{mainTechMinute}} min </span>
                            </div> 
                            <div class="textline smallFont" v-for="(itemInterim, indexInterim) in interimHour" :key="indexInterim">
                                <b class="textLen">Temps intérimaire :</b>
                                <span>{{interimHour[indexInterim]}} h </span>
                                <span>{{interimMinute[indexInterim]}} min </span>
                            </div> 
                            <div class="textline smallFont" v-for="help in helpHour.length" :key="help">
                                <b class="textLen">Temps technicien aide :</b>
                                <span>{{helpHour[help-1]}} h </span>
                                <span>{{helpMinute[help-1]}} min </span>
                            </div> 
                            <div class="textline smallFont">
                                <b class="textLen">Temps passé cumulé :</b>
                                <span>{{cumulateHour}} h </span>
                                <span>{{cumulateMinute}} min </span>
                            </div> 
                            <h4>Signatures :</h4>
                            <div class="divSigImg smallFont">
                                <span>Technicien : </span><br>
                                <img :src="dataUrlTech()" class="sigImg" alt="tech" >
                            </div>
                            <div class="divSigImg smallFont">
                                <span>Client : </span><br>
                                <img :src="dataUrlCust()" class="sigImg" alt="tech" >
                            </div>
                        </div>
                    </div>
                <div v-on:click="changeNoticeState()" class="oneImg"><img src="/assets/pdf.png" alt="PDF" /><span>Avis de passage</span></div>
                    <div id="myModal" v-on:click="changeNoticeState()" v-bind:class="[isActiveNotice ? 'modalActive' : 'modalInactive']">
                        <span class="close">&times;</span>
                        <img v-if="!intervention.noticeFiled" class="modal-content whiteback" v-on:click.stop="" src="/assets/nonotice.png">
                        <div v-else class="modal-content whiteback">
                            <h2>Avis de passage</h2>
                            <div style="color:black;">
                                <b>Type :</b>
                                <i v-if="intervention.noticeFiled.isWaterBreak">Avis de coupure d'eau</i>
                                <i v-else>Avis de passage</i>
                                <br>
                                <b v-if="intervention.noticeFiled.isWaterBreak">Début de coupure :</b>
                                <b v-else>Début de passage :</b>
                                <i>{{displayedHour(intervention.noticeFiled.startTimestamp)}}</i>
                                <br>
                                <b v-if="intervention.noticeFiled.isWaterBreak">Fin de coupure :</b>
                                <b v-else>Fin de passage :</b>
                                <i>{{displayedHour(intervention.noticeFiled.endTimestamp)}}</i>
                                <br>
                                <img :src="dataUrlNotice()">
                            </div>
                        </div>
                    </div>
                <div v-on:click="chageSketchState()" class="oneImg"><img src="/assets/img.png" alt="PDF" /><span>Croquis</span></div>
                    <div id="myModal" v-on:click="chageSketchState()" v-bind:class="[isActiveSketch ? 'modalActive' : 'modalInactive']">
                        <span class="close">&times;</span>
                        <img class="modal-content whiteback" v-on:click.stop="" :src="dataUrlSketch()">
                    </div>
                <div v-for="(item, index) in intervention.picture" :key="index" class="allImg">
                    <div v-on:click="chageModalState(index)" class="oneImg"><img data-lightbox="example-set" src="/assets/img.png" alt="PDF" /><span>Photo {{index+1}}</span></div>
                    <div id="myModal" v-on:click="chageModalState(index)"  v-bind:class="[isActive[index] ? 'modalActive' : 'modalInactive']">
                        <span class="close">&times;</span>
                        <img class="modal-content" v-on:click.stop="" :src="dataUrl(index)">
                    </div>
                </div>
            </div>
        </div>
        <modal height="80%" width="80%" name="sketchModal">
            <div class="modalDiv fullheight" >
                <div class="txtDiv">
                    <span class="modalTxt"><b>Croquis :</b></span>
                </div>    
                <VueSignaturePad  width="100%" height="calc(80vh - 165px)" :class="sigpadclass" ref="signaturePad" />    
                <button class="docBtn3 marginBotTop" type="button" v-on:click="validateSketch()">Enregistrer</button>   
            </div>    
        </modal>
        <modal height="250px" name="planningdetails">
            <div class="modalDiv">
                <div class="txtDiv">
                    <span class="modalTxt"><b>Intervention :</b><br>{{ModalType}}</span>
                </div>    
                <div class="txtDiv">
                    <span class="modalTxt"><b>Adresse :</b><br>{{ModalAddress}}</span>
                </div>
                <div class="txtDiv">
                    <span class="modalTxt"><b>Notes :</b><br>{{ModalNote}}</span>
                </div>    
                <button class="docBtn3" type="button" v-on:click="closeModal">Démarrer</button>   
            </div>    
        </modal>
        <modal height="250px" width="400px" name="validationModal">
            <div class="modalDiv">  
                <div class="txtDiv">
                    <img class="modalTxt" :src="imgValidation"/>
                </div>  
                <div class="txtDiv">
                    <span class="modalTxt">{{validationPhrase}}</span>
                </div>    
                <button class="docBtn3" type="button" v-on:click="okButton()">OK</button>   
            </div>    
        </modal>
        <modal height="80%" name="NoticeFiledModal">
            <div class="modalDiv">
                <h2>Avis déposé</h2>
                <div class="textline">
                    <input class="radioBtn" type="radio" name="isJointOwnershipRadio" :value="false" v-model="NoticeFiled.isWaterBreak">
                    <span>Avis de passage</span>
                    <input class="radioBtn" type="radio" name="isJointOwnershipRadio" :value="true" v-model="NoticeFiled.isWaterBreak" checked>
                    <span>Avis de coupure d'eau</span><br>
                </div>
                <div class="textline">
                    <b class="textLen">Date de début de {{coupurePassage}} :</b>
                    <datepicker @selected="changeHandler()" input-class="inputDate" class="wrapperDateSmall" :language="fr" v-model="pick.start.date"></datepicker>
                </div>
                <div class="textline">
                    <b class="textLen">Heure de début de {{coupurePassage}} :</b>
                    <vue-timepicker @change="changeHandler()" class="wrapperDateSmall" :minute-interval="5" v-model="pick.start.hour" hide-clear-button></vue-timepicker>
                </div>
                <div class="textline">
                    <b class="textLen">Date de fin de {{coupurePassage}} :</b>
                    <datepicker @selected="changeHandler()" input-class="inputDate" class="wrapperDateSmall" :language="fr" v-model="pick.end.date"></datepicker>
                </div>
                <div class="textline">
                    <b class="textLen">Heure de fin de {{coupurePassage}} :</b>
                    <vue-timepicker @change="changeHandler()" class="wrapperDateSmall" :minute-interval="5" v-model="pick.end.hour" hide-clear-button></vue-timepicker>
                </div>
                <div class="textline marginBotTop">
                    <b class="textLen">Ajouter une photo :</b>
                    <input type="file" ref="file" @change="readURL" style="display: none">
                    <button v-on:click="$refs.file.click()" class="btnCardCamera"><font-awesome-icon icon="camera" /></button>
                </div>
                <button class="docBtn3" type="button" v-on:click="uploadPicture()">Valider</button>
            </div>    
        </modal>
    </div>
</template>

<script>
    import axios from 'axios';
    import Datepicker from 'vuejs-datepicker';
    import {fr} from 'vuejs-datepicker/dist/locale'
    import VueTimepicker from 'vue2-timepicker'

    export default {
        name: 'Interventiondetailtech',
        components: {
            Datepicker,
            VueTimepicker
        },
        data() {
            return {
                ModalType: "Type d'intervention inconnue",
                ModalAddress: "Adresse de l'intervention inconnue",
                ModalNote: "Notes de l'intervention vide",
                validationPhrase: "L'avis a été correctement enregistré",
                sketchStatus:"Pas de croquis",
                imgValidation: "/assets/right.png",
                Name:"Client",
                sigpadclass: "signature",
                id:"",
                sketch:"/assets/nosketch.png",
                date: "01/01/2019",
                isActive: [],
                isActiveSketch: false,
                isActiveNotice: false,
                isActiveSheet: false,
                txtLocataire:"<b class='textLenSheet'>Locataire :</b> Coordonnées inconnues<br><br><br><br>",
                txtProprio:"<b class='textLenSheet'>Propriétaire :</b> Coordonnées inconnues<br><br><br><br>",
                mainTechHour:"0",
                mainTechMinute:"0",
                interimHour:["0"],
                interimMinute:["0"],
                helpHour:["0"],
                helpMinute:["0"],
                cumulateHour:"0",
                cumulateMinute:"0",
                fr:fr,
                pick:{
                    start:{
                        date: new Date(2016, 9,  16),
                        hour: {
                                HH: "10",
                                mm: "05",
                                ss: "00"
                            },
                    },
                    end:{
                        date: new Date(2016, 9,  16),
                        hour: {
                                HH: "10",
                                mm: "05",
                                ss: "00"
                            },
                    }
                },
                NoticeFiled: {
                    startTimestamp:0,
                    endTimestamp:0,
                    isWaterBreak:true,
                    picture:{
                        lastModified: {},
                        fileType: "image/png",
                        resizedFile: {},
                        imageType: "",
                        imgUrl:"/assets/add_picture_long.png",
                        files:[]
                    }
                },
                title: "",
                isInterventionSheet: false,
                intervention:{},
                coupurePassage:"coupure",
                avisPassage:"Pas d'avis",
                nbPic:"Aucune photo",
                inquiry:{},
                building:{},
                user: {},
                picture:{
                    lastModified: {},
                    fileType: "image/png",
                    resizedFile: {},
                    imageType: "",
                    imgUrl:"/assets/add_picture_long.png",
                    files:[]
                }
            };
        },
        methods:{
            dataUrlCust(){
                if(this.intervention.customerSignature){
                    return 'data:'+this.intervention.customerSignature.img.contentType+';base64,' + btoa(
                        new Uint8Array(this.intervention.customerSignature.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );
                }
                else{
                    return "/assets/nosignature.png";
                }
            },
            dataUrlTech(){
                if(this.intervention.techSignature){
                    return 'data:'+this.intervention.techSignature.img.contentType+';base64,' + btoa(
                        new Uint8Array(this.intervention.techSignature.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );
                }
                else{
                    return "/assets/nosignature.png";
                }
            },
            chageSketchState(){
                this.isActiveSketch = !this.isActiveSketch;
            },
            changeNoticeState(){
                this.isActiveNotice = !this.isActiveNotice;
            },
            changeSheetState(){
                this.isActiveSheet = !this.isActiveSheet;
            },
            dataUrlSketch(){
                if(this.intervention.sketch){
                    return 'data:'+this.intervention.sketch.img.contentType+';base64,' + btoa(
                        new Uint8Array(this.intervention.sketch.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );
                }
                else{
                    return "/assets/empty.png";
                }
            },
            dataUrlNotice(){
                if(this.intervention.noticeFiled){
                    if(this.intervention.noticeFiled.picture){
                        return 'data:'+this.intervention.noticeFiled.picture.img.contentType+';base64,' + btoa(
                            new Uint8Array(this.intervention.noticeFiled.picture.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                        );
                    }
                    else{
                        return "/assets/empty.png";
                    }
                }
                else{
                    return "/assets/empty.png";
                }
            },
            dataUrl(i){
                return 'data:'+this.intervention.picture[i].img.contentType+';base64,' + btoa(
                    new Uint8Array(this.intervention.picture[i].img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
            },
            chageModalState(i){
                var state = !this.isActive[i];
                this.isActive.splice(i, 1);
                this.isActive.splice(i, 0,state);
            },
            displayedHour(t){
                var n = new Date(t*1000);
                var y = n.getFullYear();
                var day = "0" + n.getDate();
                var month = "0" + (n.getMonth() + 1);
                var hours = "0" + n.getHours();
                var minutes = "0" + n.getMinutes();
                return  hours.substr(-2) + 'h' + minutes.substr(-2)+" " + day.substr(-2) + '/' + month.substr(-2) + '/' +y;   
            },
            getDateOfIntervention(timestamp){
                var n = new Date(timestamp*1000);
                var y = n.getFullYear();
                var day = "0" + n.getDate();
                var month = "0" + (n.getMonth() + 1);
                return  day.substr(-2) + '/' + month.substr(-2) + '/' +y;                            
            },
            openModalNotice(){
                this.$modal.show('NoticeFiledModal');
            },
            closeModalNotice(){
                this.$modal.hide('NoticeFiledModal');
            },
            openModalValidation(){
                this.$modal.show('validationModal');
            },
            closeModalValidation(){
                this.$modal.hide('validationModal');
            },
            openModal(){
                this.getInquiry(this.intervention._id);
                this.$modal.show('planningdetails');
            },
            closeModal(){
                this.$modal.hide('planningdetails');
            },
            openModalSketch(){
                this.$modal.show('sketchModal');
            },
            closeModalSketch(){
                this.$modal.hide('sketchModal');
            },
            okButton(){
                this.$modal.hide('validationModal');                
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$cookie.set('history', "");
                this.$cookie.set('historyQuery', "");
                this.$router.replace({ name: "techhome" });
            },
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('history');
                this.$cookie.delete('historyQuery');
                this.$router.replace({ name: "login" });
            },
            backbtn(){

                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);
                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);
                
                this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
                this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

                if(arrHist.length){
                    if(arrQuery[arrQuery.length-1] !== "" && arrQuery[arrQuery.length-1] !== "undefined"){
                        this.$router.replace({ name: arrHist[arrHist.length-1], query: {name: arrQuery[arrQuery.length-1]} });
                    }
                    else{
                        this.$router.replace({ name: arrHist[arrHist.length-1] });
                    }
                }
                else{
                    this.$cookie.set('currentAriane', "");
                    this.$router.replace({ name: "adminhome" });
                }
            },
            changeHandler(){
                var fin = this.pick.end.date;
                fin.setHours(parseInt(this.pick.end.hour.HH), parseInt(this.pick.end.hour.mm, 0, 0));

                var debut = this.pick.start.date;
                debut.setHours(parseInt(this.pick.start.hour.HH), parseInt(this.pick.start.hour.mm, 0, 0));

                this.NoticeFiled.startTimestamp = (debut / 1000 |0);
                this.NoticeFiled.endTimestamp = (fin/1000 |0);
            },
            readURLPicture(event){
                this.picture.imgUrl = URL.createObjectURL(event.target.files[0]);
                this.picture.files = event.target.files;
                this.picture.lastModified = event.target.files[0].lastModifiedDate;
                this.picture.fileType = event.target.files[0].type;
                
                var extension = this.picture.files[0].name.substring(this.picture.files[0].name.lastIndexOf(".")+1).toLowerCase();
                if(extension !== "jpg" && extension !== "png" && extension !== "jpeg" && extension !== "gif"){
                    alert("Image au mauvais format, veuillez réessayer avec un fichier PNG ou JPG");
                }
                else{
                    this.resizeImgPicture(event);
                }
            },
            resizeImgPicture(event){

                this.picture.files = event.target.files;
                var current_file = this.picture.files[0];
                var reader = new FileReader();

                var vm = this;
                
                reader.onload = function (event) {
                    var image = new Image();
                    image.src = event.target.result;
                    image.onload = function() {
                        var maxWidth = 500,
                            maxHeight = 250,
                            imageWidth = image.width,
                            imageHeight = image.height;
                        if (imageWidth > imageHeight) {
                            if (imageWidth > maxWidth) {
                                imageHeight *= maxWidth / imageWidth;
                                imageWidth = maxWidth;
                            }
                        }
                        else {
                            if (imageHeight > maxHeight) {
                                imageWidth *= maxHeight / imageHeight;
                                imageHeight = maxHeight;
                            }
                        }
                        var canvas = document.createElement('canvas');
                        canvas.style.display = "none";
                        canvas.width = imageWidth;
                        canvas.height = imageHeight;
                        image.width = imageWidth;
                        image.height = imageHeight;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(this, 0, 0, imageWidth, imageHeight);

                        var BASE64_MARKER = ';base64,';
                        var raw;
                        var contentType;
                        var parts;
                        if (canvas.toDataURL(current_file.type).indexOf(BASE64_MARKER) == -1) {
                            parts = canvas.toDataURL(current_file.type).split(',');
                            contentType = parts[0].split(':')[1];
                            raw = parts[1];
                            vm.picture.resizedFile = new File([new Blob([raw], {type: contentType})], "name", {type: vm.picture.fileType, lastModified: vm.picture.lastModified});
                        }
                        else{
                            parts = canvas.toDataURL(current_file.type).split(BASE64_MARKER);
                            contentType = parts[0].split(':')[1];
                            raw = window.atob(parts[1]);
                            var rawLength = raw.length;
                            var uInt8Array = new Uint8Array(rawLength);

                            for (var i = 0; i < rawLength; ++i) {
                                uInt8Array[i] = raw.charCodeAt(i);
                            }
                            vm.picture.resizedFile = new File([new Blob([uInt8Array], {type: contentType})], "name", {type: vm.picture.fileType, lastModified: vm.picture.lastModified});
                        }
                        vm.uploadBasicPicture();
                    }
                }
                reader.readAsDataURL(current_file);
                
            },
            readURL(event) {
                this.NoticeFiled.picture.imgUrl = URL.createObjectURL(event.target.files[0]);
                this.NoticeFiled.picture.files = event.target.files;
                this.NoticeFiled.picture.lastModified = event.target.files[0].lastModifiedDate;
                this.NoticeFiled.picture.fileType = event.target.files[0].type;
                
                var extension = this.NoticeFiled.picture.files[0].name.substring(this.NoticeFiled.picture.files[0].name.lastIndexOf(".")+1).toLowerCase();
                if(extension !== "jpg" && extension !== "png" && extension !== "jpeg" && extension !== "gif"){
                    alert("Image au mauvais format, veuillez réessayer avec un fichier PNG ou JPG");
                }
                else{
                    this.resizeImg(event);
                }
            },
            resizeImg(event){

                this.NoticeFiled.picture.files = event.target.files;
                var current_file = this.NoticeFiled.picture.files[0];
                var reader = new FileReader();

                var vm = this;
                
                reader.onload = function (event) {
                    var image = new Image();
                    image.src = event.target.result;
                    image.onload = function() {
                        var maxWidth = 500,
                            maxHeight = 250,
                            imageWidth = image.width,
                            imageHeight = image.height;
                        if (imageWidth > imageHeight) {
                            if (imageWidth > maxWidth) {
                                imageHeight *= maxWidth / imageWidth;
                                imageWidth = maxWidth;
                            }
                        }
                        else {
                            if (imageHeight > maxHeight) {
                                imageWidth *= maxHeight / imageHeight;
                                imageHeight = maxHeight;
                            }
                        }
                        var canvas = document.createElement('canvas');
                        canvas.style.display = "none";
                        canvas.width = imageWidth;
                        canvas.height = imageHeight;
                        image.width = imageWidth;
                        image.height = imageHeight;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(this, 0, 0, imageWidth, imageHeight);

                        var BASE64_MARKER = ';base64,';
                        var raw;
                        var contentType;
                        var parts;
                        if (canvas.toDataURL(current_file.type).indexOf(BASE64_MARKER) == -1) {
                            parts = canvas.toDataURL(current_file.type).split(',');
                            contentType = parts[0].split(':')[1];
                            raw = parts[1];
                            vm.NoticeFiled.picture.resizedFile = new File([new Blob([raw], {type: contentType})], "name", {type: vm.NoticeFiled.picture.fileType, lastModified: vm.NoticeFiled.picture.lastModified});
                        }
                        else{
                            parts = canvas.toDataURL(current_file.type).split(BASE64_MARKER);
                            contentType = parts[0].split(':')[1];
                            raw = window.atob(parts[1]);
                            var rawLength = raw.length;
                            var uInt8Array = new Uint8Array(rawLength);

                            for (var i = 0; i < rawLength; ++i) {
                                uInt8Array[i] = raw.charCodeAt(i);
                            }
                            vm.NoticeFiled.picture.resizedFile = new File([new Blob([uInt8Array], {type: contentType})], "name", {type: vm.NoticeFiled.picture.fileType, lastModified: vm.NoticeFiled.picture.lastModified});
                        }
                    }
                }
                reader.readAsDataURL(current_file);
                
            },
            getCookies: function() {
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || this.$cookie.get('role') !== "technicien chantier" || !this.$route.query.name){
                    this.logout();
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    
                    var dateNow = new Date() / 1000 | 0;
                    this.NoticeFiled.startTimestamp = (dateNow - (dateNow%1800));
                    this.NoticeFiled.endTimestamp = 1800 + (dateNow - (dateNow%1800));
                    

                    this.pick.start.date = new Date(this.NoticeFiled.startTimestamp*1000)
                    this.pick.end.date = new Date(this.NoticeFiled.endTimestamp*1000)

                    this.pick.start.hour = {
                                                HH:("0" + new Date(this.NoticeFiled.startTimestamp*1000).getHours()).substr(-2),
                                                mm:("0" + new Date(this.NoticeFiled.startTimestamp*1000).getMinutes()).substr(-2),
                                                ss:"00"
                                            };
                                                
                    this.pick.end.hour = {
                                                HH:("0" + new Date(this.NoticeFiled.endTimestamp*1000).getHours()).substr(-2),
                                                mm:("0" + new Date(this.NoticeFiled.endTimestamp*1000).getMinutes()).substr(-2),
                                                ss:"00"
                                            };
                    this.getIntervention();
                }
            },
            validateSketch() {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                if(isEmpty){
                    this.validationPhrase =  "Veuillez remplir le croquis",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
                else{
                    this.sketch = data;
                    this.uploadSketch();
                }
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            async uploadSketch(){

                var file = this.dataURLtoFile(this.sketch, 'picture.png');
                const fd = new FormData();
                fd.append('picture', file ,"picture.png");
                
                var response = await axios.put('https://so.gaviota.fr/api/building//inquiry/intervention/sketch/'+this.$route.query.name, fd);
                
                if(response){
                    this.closeModalSketch();
                    this.sketchStatus = "Croquis déjà enregistré";
                    this.validationPhrase =  "Le croquis a été correctement enregistré",
                    this.imgValidation = "/assets/right.png",
                    this.openModalValidation();
                }
                else{
                    this.closeModalSketch();
                    this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
            },
            async uploadBasicPicture(){
                const fd = new FormData();
                fd.append('picture', this.picture.resizedFile ,'picture');
                
                var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/intervention/picture/'+this.$route.query.name, fd);
                
                if(response){
                    if(this.nbPic === "Aucune photo"){
                       this.nbPic = "1 photo" 
                    }
                    else{
                        var nb = parseInt(this.nbPic.substr(0, this.nbPic.indexOf("photo")-1));
                        nb++;
                        this.nbPic = nb+" photos";
                    }
                    this.validationPhrase =  "La photo a été correctement enregistré",
                    this.imgValidation = "/assets/right.png",
                    this.openModalValidation();
                }
                else{
                    this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
            },
            async uploadPicture(){
                this.closeModalNotice();
                const fd = new FormData();
                fd.append('picture', this.NoticeFiled.picture.resizedFile ,'picture');
                
                var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/intervention/noticefiled/'+this.$route.query.name+'/'+this.NoticeFiled.startTimestamp+'/'+this.NoticeFiled.endTimestamp+'/'+this.NoticeFiled.isWaterBreak, fd);
                
                if(response){
                    this.avisPassage = "Avis déjà enregistré";
                    this.validationPhrase =  "L'avis a été correctement enregistré",
                    this.imgValidation = "/assets/right.png",
                    this.openModalValidation();
                }
                else{
                    this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
            },
            async getUserDatas(email){
                var response = await axios.get('https://so.gaviota.fr/api/userdata/email/'+email);
                if(response.data.user){
                    this.user = response.data.user;
                    this.openModal();

                }
            },
            async getInquiry(id){
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/fromintervention/'+id);
                if(response.data.inquiry){
                    this.inquiry = response.data.inquiry;
                    this.getBuilding(this.inquiry.name);

                }
            },
            async getBuilding(name){
                var response = await axios.get('https://so.gaviota.fr/api/building/frominquiry/'+name);
                if(response.data.building){
                    this.building = response.data.building;

                    var foundPhone = false;

                    if(this.building.occupantAddress.length){
                        if(this.building.occupantAddress[0].firstName !== "" ||
                            this.building.occupantAddress[0].lastName !== "" || 
                            this.building.occupantAddress[0].streetNb !== "" || 
                            this.building.occupantAddress[0].streetName !== "" || 
                            this.building.occupantAddress[0].postalCode !== "" || 
                            this.building.occupantAddress[0].city !== "" || 
                            this.building.occupantAddress[0].phoneNumber !== "" || 
                            this.building.occupantAddress[0].emailAddress !== ""
                        ){
                            this.txtLocataire = "<b class='textLenSheet'>Locataire :&nbsp;&nbsp;</b>"+
                                                this.building.occupantAddress[0].firstName + " "+this.building.occupantAddress[0].lastName+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.occupantAddress[0].streetNb + " "+this.building.occupantAddress[0].streetName+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.occupantAddress[0].postalCode + " "+this.building.occupantAddress[0].city+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.occupantAddress[0].phoneNumber +'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.occupantAddress[0].emailAddress;
                        }
                    }
                    if(this.building.ownerAddress){
                        if(this.building.ownerAddress.firstName !== "" ||
                            this.building.ownerAddress.lastName !== "" || 
                            this.building.ownerAddress.streetNb !== "" || 
                            this.building.ownerAddress.streetName !== "" || 
                            this.building.ownerAddress.postalCode !== "" || 
                            this.building.ownerAddress.city !== "" || 
                            this.building.ownerAddress.phoneNumber !== "" || 
                            this.building.ownerAddress.emailAddress !== ""
                        ){
                            this.txtProprio =   "<b class='textLenSheet'>Propriétaire :&nbsp;&nbsp;</b>"+
                                                this.building.ownerAddress.firstName + " "+this.building.ownerAddress.lastName+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.ownerAddress.streetNb + " "+this.building.ownerAddress.streetName+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                +this.building.ownerAddress.postalCode + " "+this.building.ownerAddress.city+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.ownerAddress.phoneNumber +'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.ownerAddress.emailAddress;
                        }
                    }

                    if(this.user){
                        if(this.user.address){
                            if(this.user.address.phoneNumber){
                                foundPhone = true;
                                this.ModalAddress = this.user.address.firstName+" "+
                                                    this.user.address.lastName+" - "+
                                                    this.building.buildingAddress.streetNb+" "+
                                                    this.building.buildingAddress.streetName+" "+
                                                    this.building.buildingAddress.postalCode+" "+
                                                    this.building.buildingAddress.city+" - "+
                                                    this.user.address.phoneNumber;
                            }
                        }

                    }
                    if(this.building.occupantAddress && !foundPhone){
                        if(this.building.occupantAddress.length){
                            if(this.building.occupantAddress[0].phoneNumber){
                                foundPhone = true;
                                this.ModalAddress = this.building.occupantAddress[0].firstName+" "+
                                                    this.building.occupantAddress[0].lastName+" - "+
                                                    this.building.buildingAddress.streetNb+" "+
                                                    this.building.buildingAddress.streetName+" "+
                                                    this.building.buildingAddress.postalCode+" "+
                                                    this.building.buildingAddress.city+" - "+
                                                    this.building.occupantAddress[0].phoneNumber;
                            }
                        }
                    }
                    if(this.building.ownerAddress && !foundPhone){
                        if(this.building.ownerAddress.phoneNumber){
                            foundPhone = true;
                            this.ModalAddress = this.building.ownerAddress.firstName+" "+
                                                this.building.ownerAddress.lastName+" - "+
                                                this.building.buildingAddress.streetNb+" "+
                                                this.building.buildingAddress.streetName+" "+
                                                this.building.buildingAddress.postalCode+" "+
                                                this.building.buildingAddress.city+" - "+
                                                this.building.ownerAddress.phoneNumber;
                        }                        
                    }
                }
            },
            async getIntervention(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/intervention/'+this.$route.query.name);
                if(response.data.intervention){
                    this.intervention = response.data.intervention;
                    this.ModalNote = this.intervention.note;
                    this.date = this.getDateOfIntervention(this.intervention.planning[0].startTimestamp)
                    this.title = this.intervention.planning[0].addressStr + "  -  " + this.intervention.type;
                    if(this.intervention.intervention){
                        if(this.intervention.intervention.action && this.intervention.intervention.information){
                            this.isInterventionSheet = true;
                        }
                    }
                    if(this.intervention.noticeFiled){
                        this.avisPassage = "Avis déjà enregistré";
                    }
                    if(this.intervention.sketch){
                        this.sketchStatus = "Croquis déjà enregistré"
                    }
                    if(this.intervention.picture){
                        if(this.intervention.picture.length){
                            if(this.intervention.picture.length === 1){
                                this.nbPic = this.intervention.picture.length + " photo"
                            }
                            else{
                                this.nbPic = this.intervention.picture.length + " photos"
                            }
                        }
                        else{
                            this.nbPic = "Aucune photo";
                        }
                    }
                    else{
                        this.nbPic = "Aucune photo";
                    }
                    var LOCmainTechTime =0;
                    var LOCinterimTime =[];
                    var LOChelpTime =[];
                    var LOCcumulateTime =0;
                    var foundHelp = false;
                    var foundInt = false;

                    for(var f=0; f<this.intervention.planning.length; f++){

                        if(!this.intervention.planning[f].isEstimated){
                            if(!this.intervention.planning[f].isEstimated && this.intervention.planning[f].isMain){
                                LOCmainTechTime += this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                            }
                            if(!this.intervention.planning[f].isEstimated && !this.intervention.planning[f].isMain && this.intervention.planning[f].user.idWeweb.indexOf("interimaire")===-1){
                                foundHelp = false;
                                for(var g=0; g<LOChelpTime.length; g++){
                                    if(LOChelpTime[g].user === this.intervention.planning[f].user.idWeweb){
                                        foundHelp = true;
                                        LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                        LOChelpTime[g].time = LOChelpTime[g].time + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    }
                                }
                                if(!foundHelp){
                                    LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    LOChelpTime.push({time:this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp, user:this.intervention.planning[f].user.idWeweb});
                                }
                            }
                            if(!this.intervention.planning[f].isEstimated && this.intervention.planning[f].isMain && this.intervention.planning[f].user.idWeweb.indexOf("interimaire") > -1){
                                foundInt = false;
                                for(var h=0; h<LOCinterimTime.length; h++){
                                    if(LOCinterimTime[h].user === this.intervention.planning[f].user.idWeweb){
                                        foundInt = true;
                                        LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                        LOCinterimTime[h].time = LOCinterimTime[h].time + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    }
                                }
                                if(!foundInt){
                                    LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    LOCinterimTime.push({time:this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp, user:this.intervention.planning[f].user.idWeweb});
                                }
                            }
                        }
                    }
                    this.mainTechHour = ""+Math.floor(LOCmainTechTime / 3600);
                    this.mainTechMinute = ""+Math.floor(LOCmainTechTime % 3600 / 60);

                    for(var e=0; e<LOCinterimTime.length; e++){
                        if(e>0){
                            this.interimHour.push(""+Math.floor(LOCinterimTime[e] / 3600));
                            this.interimMinute.push(""+Math.floor(LOCinterimTime[e] % 3600 / 60));
                        }
                        else{
                            this.interimHour[0] = (""+Math.floor(LOCinterimTime[e] / 3600));
                            this.interimMinute[0] = (""+Math.floor(LOCinterimTime[e] % 3600 / 60));
                        }
                    }
                    if(LOCinterimTime.length === 0){
                        this.interimHour = [];
                        this.interimMinute = [];
                    }
                    for(var d=0; d<LOChelpTime.length; d++){
                        if(d>0){
                            this.helpHour.push(""+Math.floor(LOChelpTime[d] / 3600));
                            this.helpMinute.push(""+Math.floor(LOChelpTime[d] % 3600 / 60));
                        }
                        else{
                            this.helpHour[0] = (""+Math.floor(LOChelpTime[d] / 3600));
                            this.helpMinute[0] = (""+Math.floor(LOChelpTime[d] % 3600 / 60));
                        }
                    }
                    if(LOChelpTime.length === 0){
                        this.helpHour = [];
                        this.helpMinute = [];
                    }

                    this.cumulateHour = Math.floor(""+LOCcumulateTime / 3600);
                    this.cumulateMinute = Math.floor(""+LOCcumulateTime % 3600 / 60);

                    this.getInquiry(this.intervention._id);
                }
            }
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');

    #interventiondetailtech {
        width: 90%;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 85px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    h2{
        border-bottom: 2px solid;
        border-color:#1ce83e;
        color:black;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:11;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }
    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }
    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    #circleRed {
        width: 16px;
        height: 16px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        border-radius: 8px;
        background: #ff0000;
        display:inline-block;
        position: absolute;
        top: -6px;
        right: 67px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        color:white;
        text-align: center;
        font-size:13px;
        vertical-align: middle;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
    
    #logout{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        display: block;
        border:none;
        margin: auto;
        width: 250px;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
    }
	::-webkit-scrollbar {
		width: 6px;
	}
	::-webkit-scrollbar-track {
		background: #ddd; 
	}
	::-webkit-scrollbar-thumb {
		background: #888; 
		border-radius: 3px;
	}
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
    .calendar{
        font-family: 'BenchNine', sans-serif;
        font-size: 14px;
        margin: 40px auto;
    }
    .modalDiv{
        margin:30px;
        text-align: center;
    }
    .modalAmount{
        width:100px;
        margin:auto;
    }
    .modalTxt{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
    }
    .txtDiv{
        margin-bottom: 15px; 
    }
    .modalNotes{
        background-color: #F0F0F0;
        resize: none;
        width:80%;
    }
    .docBtn3{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:#1ce83e;
        font-size: 18px;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        width: 200px;
    }
    .marginBotTop{
        margin-bottom:20px;
        margin-top:20px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .textLen{
        width:160px;
        display: inline-block;
    }
    .inputTxt{
        width:calc(100% - (100px + 50px));
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
        background-color: #F7F7F7;
        border: 1px solid #bbb;
        padding-left:5px;
        margin-left:5px;
        display: inline-block;
    }
    .select{
        width: calc(100% - (100px + 40px));
        margin-bottom:10px;
    }
    .textline{
        padding:5px;
    }
    .wrapperDateSmall{
        display: inline-block;
        width:calc(100% - (140px + 40px));
    }
    .area{
        resize: none;
        width: calc(100% - (100px + 50px));
    }
    .high{
        height: 100px;
        vertical-align:top;
    }
    .divCard{
        vertical-align: middle;
        position: relative;
        padding-left: 15px;
        padding-bottom: 25px;
        padding-top: 10px;
        border-bottom: 2px solid;
        border-color:#00000017;
    }
    .spanCardtype{
        display:inline-block;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 15px;
        position: absolute;
        left: 16px;
    }
    .spanCardstatus{
        display:inline-block;
        color:red;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 16px;
        position: absolute;
        right: 55px;
    }
    .spanCardtitle{
        display:block;
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .btnCardCamera{
        width:30px;
        height: 30px;
        border-radius: 50%;
        font-size: 18px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
    }
    #modify{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 700;
        font-size: 20px;
        display: block;
        border: 2px solid;
        border-color:#1ce83e;
        margin: auto;
        width: 250px;
        color:#1ce83e;
        cursor: pointer;
        background-color: transparent;
        border-radius:10px;
    }
    .radioBtn{
        margin-left:10px;
        margin-right:5px;
    }
    input[type='radio']:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background-color: #d1d3d1;
        content: '';
        display: inline-block;
        visibility: visible;
        border: 1px solid grey;
    }
    input[type='radio']:checked:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background: radial-gradient(#1ce83e, #ddd);
        content: '';
        display: inline-block;
        visibility: visible;
        border: 1px solid grey;
    }
    .signature{
        display: inline-block;
        border: 2px solid;
        border-color:#888;
        background-color: white;
    }
    .fullheight{
        min-height: calc(80vh - 60px);
    }
    .greyBack{
        background-color: #2b2b2b;
        color:#FFFFFF;
        font-family: 'BenchNine', sans-serif;
        font-size: 24px;
        padding-top: 15px;
        padding-bottom: 30px;
        .title{
            text-align: center;
            padding:5px;
        }
        .date{
            margin-top:-10px;
            text-align: center;
            font-size: 14px;
        }
        .img{
            margin:auto;
            text-align: center;
            margin-top:20px;
            .oneImg{
                display: inline-block;
                padding:15px;
                font-size: 14px;
                span{
                    display:block;
                }
                img{
                    display:block;
                    margin:auto;
                }
            }
            .allImg{
                font-size: 14px;
                display: inline-block;
                span{
                    display:block;
                }
                img{
                    display:block;
                    margin:auto;
                }
            }

            /* The Modal (background) */
            .modalActive {
              display: block !important; /* Hidden by default */
              position: fixed; /* Stay in place */
              z-index: 100; /* Sit on top */
              padding-top: 100px; /* Location of the box */
              left: 0;
              top: 0;
              width: 100%; /* Full width */
              height: 100%; /* Full height */
              overflow: auto; /* Enable scroll if needed */
              background-color: rgb(0,0,0); /* Fallback color */
              background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
            }
            .modalInactive {
              display: none !important; /* Hidden by default */
              position: fixed; /* Stay in place */
              z-index: 100; /* Sit on top */
              padding-top: 100px; /* Location of the box */
              left: 0;
              top: 0;
              width: 100%; /* Full width */
              height: 100%; /* Full height */
              overflow: auto; /* Enable scroll if needed */
              background-color: rgb(0,0,0); /* Fallback color */
              background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
            }

            /* Modal Content (Image) */
            .modal-content {
              margin: auto;
              display: block;
              width: 80%;
              max-width: 700px;
            }

            /* Add Animation - Zoom in the Modal */
            .modal-content{ 
              animation-name: zoom;
              animation-duration: 0.6s;
            }

            @keyframes zoom {
              from {transform:scale(0)} 
              to {transform:scale(1)}
            }

            /* The Close Button */
            .close {
              position: absolute;
              top: 15px;
              right: 35px;
              color: #f1f1f1;
              font-size: 40px;
              font-weight: bold;
              transition: 0.3s;
            }

            .close:hover,
            .close:focus {
              color: #bbb;
              text-decoration: none;
              cursor: pointer;
            }

            /* 100% Image Width on Smaller Screens */
            @media only screen and (max-width: 700px){
              .modal-content {
                width: 100%;
              }
            }
        }
    }
    .whiteback{
        color:black;
        background-color: white;
    }
    .smallFont{
        font-size: 15px;
    }
    .modalDivCenter{
        text-align: center;
    }
    .divSigImg{
        text-align: center;
        display: inline-block;
    }
    h4{
        margin:10px;
    }
    .twocolumns{        
        -webkit-column-count: 2; /* Old Chrome, Safari and Opera */
        -moz-column-count: 2; /* Old Firefox */
        column-count: 2;
    }
</style>
<style lang="scss" module>
    html>body>div>div>div>div>div>div>div>div>div>input{
                    width:100% !important;
                    font-family: 'BenchNine', sans-serif;
                    font-stretch: ultra-condensed;
                    font-size: 18px;
                    background-color: #F7F7F7;
                    border: 1px solid #bbb;
                    padding-left:5px;
                    margin-left:5px;
                    display: inline-block;
    }
    html>body>div>div>div>div>div>div>div>span>input{
                    width:100% !important;
                    font-family: 'BenchNine', sans-serif;
                    font-stretch: ultra-condensed;
                    font-size: 18px;
                    background-color: #F7F7F7;
                    border: 1px solid #bbb;
                    padding-left:5px;
                    margin-left:5px;
                    display: inline-block;
    }
    .wrapperDateSmall{
        display: inline-block;
        width:calc(100% - (140px + 40px));
    }
</style>